import { Outlet, useNavigate, useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';
import { Drawer } from '@visualfabriq/vf-ui-kit';
import { useState } from 'react';
import { PipelinesApi } from 'src/api-new/bifrost';
import { useInstances } from 'src/components/hooks/useInstances';
import { DrawerProvider } from 'src/components/molecules/Drawer';
import ModalProvider from 'src/components/molecules/Modal/ModalProvider';
import { Pipelines } from 'src/containers/Pipelines';
import { PipelineHistory } from 'src/containers/Pipelines/components/PipelinesTable/HistoryColumn/PipelineHistory';
import { PipelinesProvider } from 'src/domain/pipelines/PipelinesProvider';
import { PageGuard } from 'src/pages/PageGuard';
import { useBifrostApi } from 'src/services/useBifrostApi';
import { PAGES_CONFIG } from '../config';
import { Show } from 'src/components';
import { useDrawerStylesOverrides } from 'src/components/styles';
import { EnvVars } from 'src/services/envVars';

export function History() {
  const { pipelineId } = useParams();
  const { selectedInstance } = useInstances();
  const pipelines = useBifrostApi(PipelinesApi);
  const [isOpen, setIsOpen] = useState(() => !!pipelineId);
  const navigate = useNavigate();
  const { data } = useQuery({
    enabled: !!pipelineId,
    queryKey: ['pipeline', pipelineId],
    queryFn: () => pipelines.getPipeline({ pipelineId: pipelineId!, instanceId: selectedInstance.id }),
  });
  const drawerStylesOverrides = useDrawerStylesOverrides('right', EnvVars.isMFE);
  return (
    <Drawer
      title={data?.data.name ? `History: ${data?.data.name}` : 'History'}
      isOpen={isOpen}
      overrideStyle={drawerStylesOverrides}
      onClose={() => {
        setIsOpen(false);
        navigate('..');
      }}
      size="auto"
    >
      <Show when={isOpen}>
        <PipelineHistory pipelineId={pipelineId!} />
      </Show>
    </Drawer>
  );
}

export function PipelinesPage() {
  return (
    <PageGuard hasAccess={PAGES_CONFIG.pipelines.hasAccess}>
      <PipelinesProvider>
        <ModalProvider>
          <DrawerProvider>
            <Outlet />
            <Pipelines />
          </DrawerProvider>
        </ModalProvider>
      </PipelinesProvider>
    </PageGuard>
  );
}
